import type { ReasonRow } from '@/components/kit';

export interface ApprovalRow {
  id: string;
  kind: 'payout_run' | 'day_reopen';
  subjectRef: string;
  title: string;
  note: string | null;
  createdAt: string;
  requestedByName?: string | null;
}

/**
 * `g_m_deny` (f2e) for a payout run, and `g_l16d` for a reopen. Two boards,
 * two tables — the words are not interchangeable, which is exactly why the
 * server takes the reason as a string rather than one shared enum.
 */
export const DENY_REASONS: Record<ApprovalRow['kind'], ReasonRow[]> = {
  payout_run: [
    { key: 'figures_mismatch', label: 'The figures do not match my own',
      consequence: 'goes back to whoever sent it, unchanged' },
    { key: 'someone_missing', label: 'Someone is missing from it',
      consequence: 'the sender adds the row and sends it again' },
    { key: 'deduction_wrong', label: 'A deduction is not right',
      consequence: 'the line is named in your return' },
    { key: 'period_wrong', label: 'The period is wrong',
      consequence: 'returns with the period you expected' },
    { key: 'handled_elsewhere', label: 'Already handled somewhere else',
      consequence: 'closes without action, and says where' },
  ],
  day_reopen: [
    { key: 'not_enough_detail', label: 'Not enough detail',
      consequence: 'goes back for the missing detail — the asker sees why' },
    { key: 'wrong_day', label: 'Wrong day or wrong branch',
      consequence: 'returns pointing at the right one' },
    { key: 'handled_elsewhere', label: 'Already handled elsewhere',
      consequence: 'closes as a duplicate, with the link' },
    { key: 'new_entry', label: 'It belongs in a new entry, not a reopen',
      consequence: 'closes the request; the correction carries your reason' },
  ],
};
